/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Adam (Tuannd@rsupport.com)
 *
 * @description
 *
 * @created at Tue Sep 24 2024
 **/

import { useAtomCallback } from "jotai/utils";
import { JotaiStore } from "@/frameworks/libraries/commons";
import { atom, useAtomValue } from "jotai";
import { Configure } from "@/frameworks/libraries/utilities";

type ConferenceInfoType = {
	startTime: number;
	conferenceId: string;
	participantCount: number;
	totalUserCount: number;
	privateMeeting: boolean;
	title: string;
	sceneLevel?: string;
	sceneTypeNumber?: number;
};

const ConferenceInfoAtom = atom<Nullable<ConferenceInfoType>>(null);
const CurrentConferenceAtom = atom<typeof Configure.currentConference | null>(null);

export default function useConferenceCommon() {
	const setConferenceInfo = useAtomCallback(
		(_get, set, newInfo: Nullable<ConferenceInfoType>) => {
			set(ConferenceInfoAtom, newInfo);
		},
		{
			store: JotaiStore
		}
	);

	const setCurrentConference = useAtomCallback(
		(_, set, args: typeof Configure.currentConference) => {
			set(CurrentConferenceAtom, args);
		},
		{
			store: JotaiStore
		}
	);

	const getCurrentConference = () => {
		return useAtomValue(CurrentConferenceAtom);
	};

	const conferenceInfo = () => {
		return useAtomValue(ConferenceInfoAtom);
	};

	return { actions: { setConferenceInfo, setCurrentConference }, renderer: { conferenceInfo, getCurrentConference } };
}
